import { useContext } from 'react';

import { EventFormContext } from './event-form-context';

export const useOpenEditEventPopup = () => {
  const { onEditEvent } = useContext(EventFormContext);

  return onEditEvent;
};
